import { createContext } from "../util/create-context.js";
export const [ModalContextProvider, useModalContext] = createContext({
    name: "ModalContext",
    errorMessage: "<Modal.Header> must be used within a <Modal>",
});
//# sourceMappingURL=Modal.context.js.map